import React from 'react';
import Lottie from 'lottie-react';
import loading from 'src/assets/gif/loading.json';

const Loading = () => {
  return (
    <div className="flex h-[100vh] justify-center">
      <Lottie style={{width: '30%'}} animationData={loading} loop={true} />
    </div>
  );
};

export default Loading;
